import _ from 'lodash';

export const isRequestInProgress = (request_name, request_state) => {
    for(let i = 0, l = request_state.length; i < l; i++){
        if (request_state[i] == request_name){
            return true;
        }
    }
    return false;
};

export const spaceToUnderscore = (string) => {
    return string.split(' ').join('_');
};

export const underscoreToSpace = (string) => {
    return string.split('_').join(' ');
};

export const byteToMegabyte = (bytes) => {
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    if (bytes == 0) return '0 Byte';
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
};

export const hasConfirmedSubmission = (user_id, submission, memberships) => {
    if (user_id && submission && memberships) {
        return (
            _.filter(
                memberships,
                    membership => {
                        return membership.submission.id === submission.id &&
                            parseInt(membership.user.id) === parseInt(user_id) &&
                            membership.confirmed === true
                        ;
                }
            ).length > 0
        );
    }

    return false;
};

export const getMappedKeyEntities = (entities, id='id', type='int') => {
    return _.mapKeys(
        _.filter(
            entities,
            (entity, key) => {
                switch (type) {
                    case 'int':
                        return entity[id] !== undefined
                            && entity[id] === parseInt(key)
                        ;
                    case 'string':
                        return entity[id] !== undefined
                            && entity[id] === key
                        ;
                }
            }
        ),
        'id'
    );
};


/** WEBPACK FOOTER **
 ** ./src/helpers/helpers.js
 **/